import {AppState} from "../app";
import {FileLoader, SpriteDatabase} from "../engine/tools/SpriteLoader";
import {Vector2} from "../engine/utils/Vector2";
import {loadSoundEvents} from "../engine/tools/AudioLoader";
import {AnimationWrapMode, createAnimations, createSpriteList} from "../engine/tools/Animation";


const staticSprites = [
    // {id: "crank/crank-spindle", settings: {pivot: new Vector2(.20, 1 - .68), scale: .5}},
    // {id: "crank/crank-handle-fg", settings: {pivot: new Vector2(.5, .1), scale: .5}},
    // {id: "crank/crank-handle-bg", settings: {pivot: new Vector2(.5, .1), scale: .5}},
    // {id: "crank/crank-knob",settings: {pivot: new Vector2(.75, .75), scale: .5}},
    {id: "pump/bigpump-base", settings: {pivot: new Vector2(.5, 0.5), scale: 1}},
    {id: "pump/bigpump-lever", settings: {pivot: new Vector2(.5, 0.5), scale: 1}},
    {id: "pump/bigpump-mask", settings: {pivot: new Vector2(.5, 0.5), scale: 1}},
]

const transitionSoundsIn = [
    {
        frame: 0,
        soundId: "floor-in"
    }
]
const transitionSoundsOut = [
    {
        frame: 0,
        soundId: "floor-out"
    }
]
const animations = [

    {
        id: "clap1",
        frameRate: 30,
        sprites: createSpriteList({src: "clap1/clap1-%", start: 0, end: 292}),
        sounds: [

            {
                frame: 263,
                soundId: "pop"
            },
            {
                frame: 280,
                soundId: "clap"
            },
            {
                frame: 290,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap2",
        frameRate: 30,
        sprites: createSpriteList({src: "clap2/clap2-%", start: 0, end: 299}),
        sounds: [

            {
                frame: 270,
                soundId: "pop"
            },
            {
                frame: 288,
                soundId: "clap"
            },
            {
                frame: 297,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap3",
        frameRate: 30,
        sprites: createSpriteList({src: "clap3/clap3-%", start: 0, end: 299}),
        sounds: [

            {
                frame: 271,
                soundId: "pop"
            },
            {
                frame: 284,
                soundId: "clap3"// "floorimpact"
            },
            {
                frame: 287,
                soundId: "clap"
            },
            {
                frame: 292,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap4",
        frameRate: 30,
        sprites: createSpriteList({src: "clap4/clap4-%", start: 0, end: 299}),
        sounds: [

            {
                frame: 270,
                soundId: "pop"
            },
            {
                frame: 288,
                soundId: "clap"
            },
            {
                frame: 295,
                soundId: "clap3"
            },
            {
                frame: 299,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap5-1",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-1/clap5-1-%", start: 0, end: 75}),
        sounds: [

            {
                frame: 60,
                soundId: "pop"
            },
            {
                frame: 70,
                soundId: "clap"
            },
            {
                frame: 75,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap5-2",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-2/clap5-2-%", start: 0, end: 145}),
        sounds: [

            {
                frame: 121,
                soundId: "pop"
            },
            {
                frame: 136,
                soundId: "clap"
            },
            {
                frame: 137,
                soundId: "clap2"
            },
            {
                frame: 145,
                soundId: "clap3"
            }
        ]
    },
    {
        id: "clap5-3",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-3/clap5-3-%", start: 0, end: 172}),
        sounds: [

            {
                frame: 150,
                soundId: "pop"
            },
            {
                frame: 164,
                soundId: "clap"
            },
            {
                frame: 172,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap5-4",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-4/clap5-4-%", start: 0, end: 191}),
        sounds: [

            {
                frame: 167,
                soundId: "pop"
            },
            {
                frame: 183,
                soundId: "clap"
            },
            {
                frame: 191,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap5-5",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-5/clap5-5-%", start: 0, end: 267}),
        sounds: [

            {
                frame: 240,
                soundId: "pop"
            },
            {
                frame: 257,
                soundId: "clap"
            },
            {
                frame: 267,
                soundId: "clap2"
            }
        ]
    },
    {
        id: "clap6",
        frameRate: 30,
        sprites: createSpriteList({src: "clap6/clap6-%", start: 0, end: 169}),
        sounds: [

            {
                frame: 169,
                soundId: "pop"
            }
        ]
    },
    {
        id: "clap1+3-transition",
        frameRate: 30,
        sprites: createSpriteList({src: "clap1+3-transition/clap1+3-transition-%", start: 0, end: 29}),
        sounds: transitionSoundsOut
    },
    {
        id: "clap1+3-transition-backwards",
        frameRate: 30,
        sprites: createSpriteList({src: "clap1+3-transition/clap1+3-transition-%", start: 29, end: 0}),
        sounds: transitionSoundsIn
    },
    {
        id: "clap2-transition",
        frameRate: 30,
        sprites: createSpriteList({src: "clap2-transition/clap2-transition-%", start: 0, end: 29}),
        sounds: transitionSoundsOut
    },
    {
        id: "clap2-transition-backwards",
        frameRate: 30,
        sprites: createSpriteList({src: "clap2-transition/clap2-transition-%", start: 29, end: 0}),
        sounds: transitionSoundsIn
    },
    {
        id: "clap4-transition",
        frameRate: 30,
        sprites: createSpriteList({src: "clap4-transition/clap4-transition-%", start: 0, end: 29}),
        sounds: transitionSoundsOut
    },
    {
        id: "clap4-transition-backwards",
        frameRate: 30,
        sprites: createSpriteList({src: "clap4-transition/clap4-transition-%", start: 29, end: 0}),
        sounds: transitionSoundsIn
    },
    {
        id: "clap5-transition",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-transition/clap5-transition-%", start: 0, end: 29}),
        sounds: transitionSoundsOut
    },
    {
        id: "clap5-transition-backwards",
        frameRate: 30,
        sprites: createSpriteList({src: "clap5-transition/clap5-transition-%", start: 29, end: 0}),
        sounds: transitionSoundsIn
    },
    {
        id: "clap6-transition-start",
        frameRate: 30,
        sprites: createSpriteList({src: "clap6-transition-start/clap6-transition-start-%", start: 0, end: 29}),
        sounds: transitionSoundsIn
    },
    {
        id: "clap6-transition-end",
        frameRate: 30,
        sprites: createSpriteList({src: "clap6-transition-end/clap6-transition-end-%", start: 0, end: 29}),
        sounds: transitionSoundsOut
    },
]

const soundEvents = {
    path: "resources/sounds/",
    events: {
        // "crank-locked": {
        //     rate: {min: 0.8, max: 1.0},
        //     volume: {min: 0.2, max: 1.0},
        //     sounds: ["pull-music01.wav", "pull-music02.wav", "pull-music03.wav", "pull-music04.wav", "pull-music05.wav"]
        // },
        // "crank-unlocked": {
        //     rate: {min: 0.3, max: 4.0},
        //     volume: {min: 0.2, max: .4},
        //     sounds: ["pull-music01.wav", "pull-music02.wav", "pull-music03.wav", "pull-music04.wav", "pull-music05.wav"]
        // },
        // "button-push": {
        //     sounds: ["button-push-01.wav", "button-push-02.wav", "button-push-03.wav"]
        // },
        // "button-release": {
        //     sounds: ["button-release-01.wav", "button-release-02.wav", "button-release-03.wav"]
        // },
        "pop": {
            rate: {min: 1.0, max: 1.5},
            volume: 0.6,
            sounds: ["balloon-pop.wav"]
        },
        "clap": {
            volume: 1,
            rate: {min: 1, max: 1.3},
            sounds: ["impact-big-1.wav", "impact-big-2.wav", "impact-big-3.wav"]
        },
        "clap2": {
            volume: 1,
            rate: {min: 1, max: 1.3},
            sounds: ["impact-small-1.wav", "impact-small-2.wav", "impact-small-3.wav"]
        },
        "clap3": {
            volume: .2,
            rate: {min: 1, max: 1.3},
            sounds: ["impact-small-1.wav", "impact-small-2.wav", "impact-small-3.wav"]
        },
        "pump": {
            options: {
                loop: true,
            },
            volume: {min: 0.0, max: .4},
            rate: {min: .8, max: .4},
            sounds: ["balloon-air-loop.wav"]
        },
        "pump_release": {
            options: {
                loop: true,
            },
            volume: {min: 0.0, max: .01},
            rate: {min: 1.5, max: .3},
            sounds: ["balloon-air-loop.wav"]
        },
        "tension_pump": {
            options: {
                loop: true,
            },
            volume: {min: 0.0, max: .07},
            rate: {min: 0.1, max: 2.5},
            sounds: ["tension.wav"]
        },
        "tension_release": {
            options: {
                loop: true,
            },
            volume: {min: 0.0, max: 1},
            rate: {min: .8, max: 1.2},
            sounds: ["fart-loop.wav"]
        },
        "floor-in": {
            volume: 1,
            sounds: ["floor-in.wav"]
        },
        "floor-out": {
            volume: 1,
            sounds: ["floor-out.wav"]
        },
        "pump-move": {
            options: {
                loop: true,
            },
            volume: {min: 0.0, max: .05},
            rate: {min: 1.1, max: 2.2},
            sounds: ["pump-move.wav"]
        },
        /* "pump-touch": {
             volume: {min: 0.05, max: .5},
             rate: {min: .6, max: 1.0},
             sounds: ["touch-weak.wav"]
         },*/
        "room": {
            options: {
                loop: true,
            },
            volume: 1,
            sounds: ["room-tone-loop.mp3"]
        },
        "floorimpact": {
            volume: .2,
            sounds: ["character-fallfromsky-impact_b_03-short.wav"]
        }
    }
}

const spriteSheets = [
    "clap4-transition",
    "clap1",
    "clap1+3-transition",
    "clap2-transition",
    "clap2",
    "clap3",
    "clap4",
    "clap5-1",
    "clap5-2",
    "clap5-3",
    "clap5-4",
    "clap5-5",
    "clap5-transition",
    "clap6-transition-end",
    "clap6-transition-start",
    "clap6"
]

export async function preload(globals: AppState) {

    const fileLoader = new FileLoader({})

    globals.spriteDatabase = new SpriteDatabase({
        fileLoader: fileLoader,
        basePath: "resources/sprites/"
    })

    globals.animations = createAnimations(animations)

    await Promise.all(spriteSheets.map(async ss=>{
        await fileLoader.loadAtlas(`${ss}/${ss}`,`resources/spritesheets/${ss}.png`)
    }))


    await globals.spriteDatabase.loadSprites(...staticSprites, ...animations.map(l => l.sprites).flat())
    globals.soundEvents = await loadSoundEvents(soundEvents)
}

